<div *ngIf="!!config" [id]="config.id" [class]="config.classes"></div>